import React, { useEffect, useState } from 'react'
import { Button, Modal, Space, Table } from 'antd'
import Icon from '@ant-design/icons'
import { AxiosResponse } from 'axios'
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons'
import ViewPage from '../../../../Components/ViewPage'
import {
  delFormulacao,
  getFormulacao,
  TypeFormulacao,
} from '../../../../services/recomendacao/formulacao'
import { pagination } from '../../../../Components/Default'
import { IconAlert } from '../../../../Components/iconsAlert'
import { Notification } from '../../../../Components/notification'
import FormFormulacao from '../../../../Components/recomendacao/formulacao'
import Icons from '../../../../Components/Icons'
import { successAlert } from '../../../../utils/alert'

const RecomendaFormulacao: React.FC = () => {
  const [visibleForm, setVisibleForm] = useState(false)
  const [update, setUpdate] = useState(0)

  const [dataFormulacao, setDataFormulacao] = useState([])
  const [tempFormulacao, setTempFormulacao] = useState([])

  const [loadingTable, setLoadingTable] = useState(false)

  const listFormulacao = async () => {
    setLoadingTable(true)
    const resp: AxiosResponse<TypeFormulacao> = await getFormulacao({
      pagination: -1,
    })

    setDataFormulacao(resp.data.itens)
    setTempFormulacao(resp.data.itens)
    setLoadingTable(false)
  }

  const handleClickNewTipo = () => {
    setVisibleForm(true)
  }

  const handleClickEdit = (cod) => {
    setUpdate(cod)
    setVisibleForm(true)
  }

  const handleSearch = (data) => {
    setLoadingTable(true)
    const dados = dataFormulacao
    const nome: any = data.target.value.toLowerCase()

    setTimeout(() => {
      const response = dados.filter((info) => info.nome.toLowerCase().indexOf(nome) !== -1)
      setTempFormulacao(response)
      setLoadingTable(false)
    }, 500)
  }

  const handleClickTrash = (cod, nome) => {
    Modal.confirm({
      title: `Deseja remover a formulação ${nome}?`,
      icon: <IconAlert type='confirm' size={6} />,
      okText: 'Sim',
      cancelText: 'Não',
      cancelButtonProps: {
        type: 'primary',
        danger: true,
      },
      onOk: async () => {
        const response = await delFormulacao(cod)

        if (response.status === 200) {
          successAlert('Formulação removido com sucesso!');

          listFormulacao()
        }
      },
    })
  }

  const handleCloseForm = (data) => {
    setVisibleForm(data)
    if (data) {
      listFormulacao()
    } else {
      setUpdate(0)
    }
  }

  useEffect(() => {
    listFormulacao()
  }, [])

  return (
    <ViewPage
      title='Formulação'
      btnClick={handleClickNewTipo}
      search
      inputChange={handleSearch}
      content={
        <FormFormulacao
          onClose={(data) => handleCloseForm(data)}
          visible={visibleForm}
          update={update}
        />
      }
    >
      <Table
        rowKey='cod'
        loading={loadingTable}
        size='small'
        dataSource={tempFormulacao}
        scroll={{ y: 'calc(90vh - 275px)' }}
        pagination={pagination}
        columns={[
          {
            key: 1,
            title: 'Nome',
            dataIndex: 'nome',
          },
          {
            key: 2,
            title: 'Sigla',
            dataIndex: 'sigla',
          },
          {
            key: 3,
            title: 'Tipo nome',
            dataIndex: 'tipo_nome',
          },
          {
            key: 4,
            width: 90,
            title: 'Ações',
            dataIndex: 'cod',
            render: (data, record) => (
              <Space>
                <Button
                  shape='circle'
                  type='default'
                  onClick={() => handleClickEdit(data)}
                  icon={<Icon component={() => <Icons icon={faPen} />} />}
                />
                <Button
                  shape='circle'
                  type='primary'
                  danger
                  onClick={() => handleClickTrash(data, record.nome)}
                  icon={<Icon component={() => <Icons icon={faTrash} />} />}
                />
              </Space>
            ),
          },
        ]}
        footer={() => (
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'right',
            }}
          >
            <b>Total geral: {dataFormulacao.length}</b>
          </div>
        )}
      />
    </ViewPage>
  )
}

export default RecomendaFormulacao
